
import React from 'react';

import UsekListDetailView from './UsekListDetail.view';

const UsekListDetail = ({
    usekMezItems
}) => {

    const usekCount = usekMezItems ? usekMezItems.length : 0;

    return (
        <UsekListDetailView
            usekCount={usekCount}
        />
    );
}

export default UsekListDetail;
